import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7789993e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-8 relative" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle w-2 h-2 bg-white rounded-full" }),
  /*#__PURE__*/_createElementVNode("div", { class: "circle circle__2 w-2 h-2 bg-white rounded-full" }),
  /*#__PURE__*/_createElementVNode("div", { class: "circle circle__3 w-2 h-2 bg-white rounded-full" })
], -1))
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, _hoisted_2))
}